export const selectCurrentFarm = state => state.farm.currentFarm

export const selectCurrentFarmId = state => selectCurrentFarm(state)?.id

export const selectCurrentFarmProperties = state => state.farm.currentFarm.properties

export const selectUserFarms = state => state.farm.farms

export const selectInFarmContext = state => state.farm.inFarmContext
